import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { AppAccountPost, AppRawDone, AppRawOptions } from "./AppAccountPost";
import { AppChatArchiveRules, AppChatArchiveWho, AppChatSettingValue } from "./AppChatArchiveRules";

// AppChatArchive - THE TRANSPORT of one chat's settings: a GET that reads (the key in the Authorization header, never
// the URL) and a POST that writes one explicit value. What is done with the answers is `AppChatSettingsRun` (the "Chat
// settings" dialog) and `AppChatListRead` (the Starred / Archived list views).
// ⚠ The per-menu-item controller that lived here (one polling reader per setting, with its "status unknown" label) was
// retired on 2026-10-13 together with `AppChatArchiveScreen`, `AppChatArchiveView`, `AppChatQuick` and `AppChatSettingsApi`.

export interface IAppChatArchiveCall { Send(): void; Abort(): void; }
export type AppChatArchiveAsk = () => AppChatArchiveWho;

/** Domain adapter over the canonical raw transport. GET reads; only explicit desired values write. */
export class AppChatArchiveApi {
    public Create = (Who: AppChatArchiveWho, Archived: AppChatSettingValue | null, Done: AppRawDone, Combined: boolean = false): IAppChatArchiveCall => {
        if (getCoreUtils().KErrorMode === true) { return new AppAccountPost("", "", Done); }
        try {
            const Options: AppRawOptions = new AppRawOptions();
            let Body: string = "";
            Options.TimeoutMs = AppChatArchiveRules.ReadTimeoutMs;
            if (Archived === null) { Options.Method = "GET"; Options.Headers.Authorization = "Bearer " + Who.Key; }
            else { Options.TimeoutMs = AppChatArchiveRules.SetTimeoutMs; Body = AppChatArchiveRules.Body(Who, Archived, Combined); }
            return new AppAccountPost(AppChatArchiveRules.Url(Who, Archived === null, Combined), Body, Done, Options);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppChatArchiveApi.Create");
            return new AppAccountPost("", "", Done);
        }
    };
}
